import { forwardRef } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterPanel, FilterRow, HeaderFilter, Pager, Paging } from 'devextreme-react/data-grid';
import 'devextreme-react/text-area';

import { ActionsRow, OptionDropDown } from 'components/ActionsRow';
import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import DataSource from 'devextreme/data/data_source';

import { Account } from '../Accounts.entity';

type Props = {
  accountList: DataSource;
  onCreate: () => void;
  onEdit: (id: number) => void;
  onOpenHistory: (id: number) => void;
  onChangePassword: (id: number) => void;
  onBlock: (id: number, isBlocked: boolean) => void;
};

const DROP_DOWN_OPTIONS = (isBlocked: boolean) => [
  { type: 'EDIT', name: 'Редактирование', icon: 'edit' },
  { type: 'BLOCK', name: isBlocked ? 'Разблокировать' : 'Блокировать', icon: 'unlock' },
  { type: 'CHANGE_PASSWORD', name: 'Смена пароля', icon: 'key' },
  { type: 'HISTORY', name: 'История изменений', icon: 'user' },
];

export const AccountListPage = forwardRef<DataGrid, Props>(
  ({ accountList, onCreate, onEdit, onBlock, onChangePassword, onOpenHistory }, ref) => {
    const handleClickDropDown = (option: OptionDropDown, account: Account) => {
      if (option.type === 'EDIT') {
        onEdit(account.id);
      }
      if (option.type === 'BLOCK') {
        onBlock(account.id, account.isBlocked);
      }
      if (option.type === 'CHANGE_PASSWORD') {
        onChangePassword(account.id);
      }
      if (option.type === 'HISTORY') {
        onOpenHistory(account.id);
      }
    };

    return (
      <div>
        <div className="pr-2 pt-1">
          <AppLayoutTop title="">
            <ClaimsProvider claimsBlock={['CanEditUser']}>
              <Button width={120} text="Добавить" type="default" onClick={onCreate} />
            </ClaimsProvider>
          </AppLayoutTop>
        </div>
        <AppCard>
          <DataGrid
            dataSource={accountList}
            showBorders={false}
            loadPanel={{
              enabled: true,
              text: 'Загрузка',
            }}
            remoteOperations={true}
            allowColumnResizing
            columnResizingMode="nextColumn"
            columnMinWidth={50}
            allowColumnReordering
            ref={ref}
          >
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <HeaderFilter visible />
            <Column dataField="userName" caption="Логин" />
            <Column dataField="employeeName" caption="ФИО" />
            <Column dataField="role" caption="Роль" />
            <Column dataField="isBlocked" caption="Блокировка" />

            <Column
              dataField="actions"
              caption=""
              width={120}
              allowFiltering={false}
              allowSorting={false}
              cellRender={(data) => (
                <>
                  <ClaimsProvider claimsBlock={['CanEditUser']}>
                    <ActionsRow
                      data={data}
                      actionOptions={DROP_DOWN_OPTIONS(data.data.isBlocked)}
                      handleClickDropDown={handleClickDropDown}
                    />
                  </ClaimsProvider>
                </>
              )}
            />

            <Paging defaultPageSize={15} />
            <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
          </DataGrid>
        </AppCard>
      </div>
    );
  },
);
